import script from "./PreviewAddressList.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewAddressList.vue?vue&type=script&setup=true&lang=js"

import "./PreviewAddressList.vue?vue&type=style&index=0&id=20e0fcc7&lang=scss"

const __exports__ = script;

export default __exports__